onComplete(function () {

	const svgs = [...document.querySelectorAll('.step-card svg')];
	const maxHeight = Math.max(...svgs.map(svg => svg.clientHeight));
	svgs.forEach(svg => svg.style.height = `${maxHeight}px`);

});